import type { StoreApi, UseBoundStore } from 'zustand';

export type { UseBoundStore } from 'zustand';

/**
 * Refer: https://docs.pmnd.rs/zustand/guides/auto-generating-selectors
 */

/**
 * NOTE: this is used when store is created using zustand/create which return a store hook
 * Refer: https://docs.pmnd.rs/zustand/guides/auto-generating-selectors#create-the-following-function:-createselectors
 */
export type WithSelectors<S> = S extends {
  getState: () => infer T;
}
  ? S & { hooks: { [K in keyof T as `use${Capitalize<string & K>}`]: () => T[K] } }
  : never;

export type StoreApiWithSelectors<S> = WithSelectors<UseBoundStore<StoreApi<S>>>;

export const createSelectors = <S extends UseBoundStore<StoreApi<object>>>(
  _store: S,
): WithSelectors<S> => {
  const store = _store as WithSelectors<typeof _store>;
  store.hooks = {} as typeof store.hooks;
  for (const k of Object.keys(store.getState())) {
    const hookName = `use${k.charAt(0).toUpperCase()}${k.slice(1)}`;
    (store.hooks as Record<string, unknown>)[hookName] = () => store((s) => s[k as keyof typeof s]);
  }

  return store;
};
